<template>
    <div>
        <NavBarLight></NavBarLight>
        <div class="content-start">
            <div class="container-fluid" id="main-container">
                <div class="row" id="challenge-content">
                    <div class="card col-sm-7 mx-auto text-left" id="challenge-content-text">
                        <h5>Hi {{getName}} 👋 </h5><br>
                        <div class="details">Please feel free to fill out details about your career portfolio. A complete
                            portfolio will help us serve you better. Cheers 🍻
                        </div>
                        <DetailsForm from_profile="true" @submit="uploadContent"></DetailsForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavBarLight from '@/components/NavBarLight.vue'
import DetailsForm from '@/components/DetailsForm.vue'
import firebase from '../services/firebase'

export default {
    name: 'EditProfile',
    components: {
        NavBarLight,
        DetailsForm
    }, 
    data: function() {
        return {
            logged_in_user: null
        }
    },
    components: {
        NavBarLight,
        DetailsForm
    },
    created: function() {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                this.logged_in_user = user;
            } 
        });
    },
    computed: {
        getName: function() {
            var full_name = '';
            if (this.logged_in_user) {
                full_name = this.logged_in_user.displayName;
                console.log("full name is " + full_name);
            } else {
                full_name = "there";
            }
            
            return full_name;
        }
        
    },
    methods: {
        uploadContent: function(resume, links) {
            const promises = [];
            var resumeLocation = "images/" + this.logged_in_user.uid + 
            "/resume/";

            if (resume !== null) {
                var uploadTask = firebase.storage().ref().child("/" + resumeLocation).put(resume);

                let behanceLink = links.behanceLink;
                let dribbbleLink = links.dribbbleLink;
                let linkedinLink = links.linkedinLink;
                let githubLink = links.githubLink;
                
                console.log("In Details component, need to upload file " + resume.name);
                console.log("In Details component, need to upload links: behance is " + links.behanceLink);

                firebase.storage().ref().child("/" + resumeLocation).getDownloadURL().then((url) => {

                    firebase.database().ref('users/' + this.logged_in_user.uid).update({
                        behance: behanceLink, 
                        dribbble: dribbbleLink, 
                        linkedin: linkedinLink, 
                        github: githubLink,
                        resume: url
                    });

                    mixpanel.track("details_submitted", {
                        "user_id": this.logged_in_user.uid,
                        "behance": behanceLink,
                        "dribbble": dribbbleLink,
                        "linkedin": linkedinLink,
                        "github": githubLink
                    });

                    
                });
            }

            this.$router.push("/dashboard");

            
        }
    }
}
</script>

<style scoped>

    .card {
		margin-top:5px; 
		margin-bottom:20px; 
		padding-top:50px;
        padding-bottom:20px;
        padding-left:50px;
        padding-right:0px;
		border:none;
		box-shadow: 2px 1px 2px 0px rgba(46,61,73,0.15);
        transition: all 0.3s ease;
		font-family: Helvetica;
	}

    .content-start {
        margin-top:58px;
    }

    #main-container {
        color:#222;
        background-color:#f8faff !important;
    }

    #challenge-content {
        margin-left:0%;
        margin-right:0%;
    }

    #challenge-content-text {
        padding-right:7%;
    }

</style>
